module.exports = __webpack_public_path__ + "4899889a3916b84db043cd0a400949e8.svg";